export default "__VITE_ASSET__HrS7$viZ__"